export default "__VITE_ASSET__CmxLWf_o__"